module.exports = __webpack_public_path__ + "static/img/0.e7901c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/0.png
// module id = bqNv
// module chunks = 0